import type { IUiPermissions } from 'modules/login/model/login.dto'
import { defineStore } from 'pinia'

export const usePermissionsStore = defineStore('permissions', () => {
  const showAiKnowledgeBase = ref(false)
  const showOutboxQueue = ref(false)

  function setPermissions(data: IUiPermissions) {
    showAiKnowledgeBase.value = data.show_ai_knowledge_base
    showOutboxQueue.value = data.show_outbox_queue ?? false
  }

  function resetPermissions() {
    showAiKnowledgeBase.value = false
    showOutboxQueue.value = false
  }

  return {
    showAiKnowledgeBase,
    showOutboxQueue,
    setPermissions,
    resetPermissions,
  }
}, { persist: true })
